import openForm from './open-form';
import showAlert from './show-alert';
import openEntityDetails from './open-entity-details';
import getProcessForms from './get-process-forms';
import reload from './reload';
import signOut from './sign-out';
import reIssueTokens from './re-issue-tokens';
import broadcastMessage from './broadcast-message';
import showTour from './trigger-tour';
import closeEntityDetails from './close-entity-details';
import updateUrl from './update-url';
var actionDispatcher = {
  openEntityDetails: openEntityDetails,
  openForm: openForm,
  showAlert: showAlert,
  showTour: showTour,
  getProcessForms: getProcessForms,
  reload: reload,
  signOut: signOut,
  reIssueTokens: reIssueTokens,
  broadcastMessage: broadcastMessage,
  updateUrl: updateUrl,
  closeEntityDetails: closeEntityDetails
};
export default actionDispatcher;